import { styled } from "linaria/react";
import Head from "next/head";
import { theme } from "@project/shared/src/theme";
const Wrapper = /*#__PURE__*/styled("div")({
  name: "Wrapper",
  class: "w674pfi"
});
const HeadingWrapper = /*#__PURE__*/styled("div")({
  name: "HeadingWrapper",
  class: "hab60ja"
});
const Description = /*#__PURE__*/styled("div")({
  name: "Description",
  class: "d3ac5af"
});
const BgDiv = /*#__PURE__*/styled("div")({
  name: "BgDiv",
  class: "benkkd9"
});
const Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "cy0a2ge"
});
const Subtitle = /*#__PURE__*/styled("h2")({
  name: "Subtitle",
  class: "s1vjfm8i"
});
const Banner = /*#__PURE__*/styled("div")({
  name: "Banner",
  class: "beg0m3z"
});
const List = /*#__PURE__*/styled("li")({
  name: "List",
  class: "l1mpoull"
});
const Content = /*#__PURE__*/styled("p")({
  name: "Content",
  class: "c12wv0b6",
  vars: {
    "c12wv0b6-1": [({
      center,
      right
    }) => center ? "center" : right ? "right" : "unset"]
  }
});

const Privacy = () => {
  const ListItems = (items: string[]) => <>
      {items.map((each, index) => <List key={index}>{each}</List>)}
    </>;

  const OL = (items: string[]) => <ol>{ListItems(items)}</ol>;

  return <>
      <Head>
        <title>
          事業者等規約 | オフサイトミーティングを一括手配：コワーケーション.com
        </title>
        <meta name="keywords" content="事業者,規約,コワーケーション,合宿,研修,オフサイトミーティング,チームビルディング,役員合宿" />
        <meta name="description" content="法人の経営合宿やチームビルディング合宿、オフサイトミーティングのために、全国の施設と研修・体験コンテンツを代行して一括手配するコワーケーション.com。事業者規約についてはこちらから。コワーケーション.comでは現状の課題やご希望から最適なコワーケーション体験をご提案いたします。" />
      </Head>
      <Banner>
        <Wrapper>
          <HeadingWrapper>
            <h1>CONTENT SUPPLIERS</h1>
            <h4>コワーケーション.com 事業者等規約</h4>
          </HeadingWrapper>
        </Wrapper>
        <BgDiv>
          <img src={"/terms-bg.svg"} />
        </BgDiv>
      </Banner>
      <Description>
        コワーケーション.com
        事業者等規約（以下「本規約」といいます。）には、PerkUP株式会社（以下「当社」といいま
        す。）の提供するサービス「コワーケーション.com」（以下「本サービス」といいます。）のご利⽤にあた
        り、施設事業者（宿泊施設事業者を含みます。以下同じ。）及びコンテンツ事業者の皆様に遵守し
        ていただかなければならない事項及び当社と施設事業者の皆様との間の権利義務関係が定めら
        れております。本サービスの施設事業者となることを希望される⽅は、本規約に同意する前に、必
        ず全⽂お読み下さいますようお願いいたします。
      </Description>
      <Container>
        <Subtitle>第 1 条 適 ⽤</Subtitle>
        <Content>
          本規約は、施設事業者及びコンテンツ事業者（以下「事業者等」といいます。）が⾃⼰の管理する
          施設及びコンテンツの利⽤者を募集するために、当社が運営する本サービスを利⽤することに関
          し、当社と事業者等の間の権利義務関係を定めることを⽬的とし、当社と事業者等との間の本サー
          ビスに関する全ての法律関係に適⽤されるものとします。なお、本規約と個別規約等の各規定が
          矛盾又は抵触する場合には、個別規約等の規定が優先して適用されるものとします。
        </Content>
        <Subtitle>第 2 条 定 義</Subtitle>
        <Content>
          本規約において使⽤される以下の⽤語は、各々以下に定める意味を有するものとします。
        </Content>
        {OL(["「外部SNSサービス」とは、Facebookその他の事業者が提供している当社所定のソーシャル・ネットワーキング・サービスで、本サービスの実施に利用されるサービスを意味します。", "「コンテンツ」とは、コンテンツ事業者が利用者に対して提供するオンライン又はオフラインによる体験型アクティビティプログラム、研修プログラム（ハラスメント研修、コンプライアンス研修、ゲームを用いた研修等を含みこれらに限りません。）、地域アクティビティ（農業体験を含みます。）、ガイドツアー、各種会議体のファシリテートその他のプログラムもしくは役務を意味します。", "「知的財産権」とは、著作権、特許権、実用新案権、商標権、意匠権その他の知的財産権（それらの権利を取得し、又はそれらの権利につき登録等を出願する権利を含みます。）を意味します。", "「当社ウェブサイト等」とは、そのドメインが「https://co-workation.com/」である当社が運営するウェブサイト（理由の如何を問わず当社のウェブサイトのドメイン又は内容が変更された場合は、当該変更後のウェブサイトを含みます。）及び当社がリリースし、又は、将来リリースするアプリケーション（iOS版、Android版を含み、これに限りません。）を意味します。", "「本サービス」とは、当社が、事業者等のため、利用者（第2条で定義します。）に対するサービスの提供について、代理して契約を締結し、又は媒介するサービスをいいます。", "「利用者」とは、本サービスを利用する登録ユーザーとして登録され、本サービスを利用し、又は、利用しようとする個人又は法人を意味します。"])}
        <Subtitle>第 3 条 登 録</Subtitle>
        <ol>
          <List>
            本サービスの事業者等として登録を希望する者（以下「登録希望者」といいます。）は、本規約
            を遵守することに同意し、かつ当社の定める⼀定の情報（以下「登録情報」といいます。）を当
            社の定める⽅法で当社に提供することにより、当社に対し、本サービスの事業者等としての利
            ⽤の登録を申請することができるものとします。なお、宿泊施設の登録希望者は、以下のいず
            れかに該当することを登録情報として明らかにしなければならず、いずれかの条件を備えない
            施設において宿泊サービスを提供することはできないことについて異議なく同意します。
            {OL(["施設事業者が旅館業法第3条に定める許可を受けていること及び施設が旅館業法上宿泊施設として備えるべき条件を備えていること", "前号に定めるほか、旅館業法に定める旅館業を⾏うこと及び当該施設を宿泊施設として貸し出すことが法令（国家戦略特別区域法を含む）により許容されていること", "施設事業者が運営する施設について住宅宿泊事業法に定める届出を行い届出番号が付与されていること及び当該施設が住宅宿泊事業法上施設として備えるべき条件を備えていること", "農山漁村での生活体験等の受入サービスであること（施設事業者が受け取る対価が農山漁村生活体験の指導料、食事代の実費、消耗品の実費のみであり、宿泊に関して営利を目的とせず、かつ宿泊料を受けないものに限る。なお、農林漁家における民泊に関して取扱指針、実施方針、取扱要綱その他のガイドライン（以下、「民泊ガイドライン」といいます。）が設けられている都道府県においては、当該民泊ガイドラインに定める基準を満たしており、当該民泊ガイドラインの定めに従い、各都道府県に対する届出、登録その他の措置が行われていることを条件とします。）", "前各号に定めるほか、旅館業法その他の法令に抵触しない範囲で提供される宿泊サービスであること（イベント開催時における宿泊施設の不足に対応する公共性の高い宿泊サービスと認められるものを含みます）"])}
          </List>
          {ListItems(["登録の申請は必ず本サービスを利⽤する個⼈⼜は法⼈⾃⾝が⾏わなければなりません。また、登録希望者は、登録の申請にあたり、真実、正確かつ最新の情報を当社に提供しなければなりません。", "当社は、当社の基準に従って、登録希望者の登録の可否を判断し、当社が登録を認める場合にはその旨を登録希望者に通知し、この通知により登録希望者の事業者等としての登録は完了したものとします。", "前項に定める登録の完了時に、事業者等は本サービスを当社の定める⽅法で利⽤することができるようになるものとします。"])}
          <List>
            {" "}
            当社は、登録希望者が、以下の各号のいずれかの事由に該当する場合は、登録を拒否する
            ことができるものとします。
            {OL(["当社諸規約に違反するおそれがあると当社が判断した場合", "当社に提供された登録情報の全部⼜は⼀部につき虚偽、誤記⼜は記載漏れがあった場合", "過去に本サービスの利⽤の登録を取り消された者と同一人物であると合理的に判断できる者の再登録である場合", "未成年者、成年被後⾒⼈、被保佐⼈⼜は被補助⼈のいずれかであり、法定代理⼈、後⾒⼈､保佐⼈⼜は補助⼈の同意等を得ていなかった場合", "反社会的勢⼒等である、⼜は資⾦提供その他を通じて反社会的勢⼒等の維持、運営若しくは経営に協⼒若しくは関与する等反社会的勢⼒等との何らかの交流若しくは関与を⾏っていると当社又は第三者（当社が提携する決済代行会社及びデジタルアイデンティティ事業者を含みますがそれらに限りません。）が判断した場合", "その他、当社が登録を適当でないと判断した場合"])}
          </List>
          <List>
            登録希望者は、自身の施設又はコンテンツを本サービスに掲載し、当社にその対価として所定の掲載料を支払うものとします。
          </List>
        </ol>
        <Subtitle>第 4 条 登録情報の変更</Subtitle>
        {OL(["事業者等は、担当者の変更や法人成りをした場合等、登録情報に変更があった場合は、遅滞なく、当社の定める⽅法により、当該変更事項を当社に通知し、当社から要求された資料を提出するものとします。", "当社は、事業者等が記載する登録情報が本サービスの対象としてふさわしくないと判断した場合又は当社の基準を満たしていないと判断した場合、その理由とともに事業者等に対して登録情報を変更するよう求めることができ、事業者等は合理的な理由がある場合を除いて修正に応じるものとします。また、当社は、写真や記載内容から登録情報等が本サービスの対象としてふさわしくないことが明らかであると判断した場合、事業者等へ通知をした上で、登録情報（文章、アメニティ項目その他の情報）の追加・削除を行うことができるものとします。", "当社は、事業者等が記載する登録情報を、現況に最適化するため、事業者等に通知することなく任意に修正することができるものとします。"])}

        <Subtitle>第 5 条 本サービスの利⽤</Subtitle>
        <ol>
          <List>
            事業者等は、本規約の有効期間中、当社諸規約に定める条件に従い、利⽤者を募集するた
            めに、本サービスを利⽤することができます。
          </List>
          <List>
            本サービスの利⽤にあたり、事業者等は、以下の⾏為を実施するものとします
            {OL(["当社に対する情報の提供", "利用者からの問い合わせ、申込み、予約の変更・取消、苦情その他の連絡に対する対応", "利用者との個別契約の締結及びその適切かつ誠実な履⾏"])}
          </List>
          <List>
            事業者等による本サービスの利⽤にあたり、当社は、⾃⼰の裁量に基づき、事業者等に対
            し、以下のサービスを提供します。
            {OL(["本サイトの管理及び運営", "利用者の開拓及び利用者への営業", "コンテンツ企画", " 利⽤料⾦及び飲⾷利⽤料⾦の回収代⾏", "売上報告及び⽀払通知書の送付"])}
          </List>
          <List>
            事業者等は、当社の定める⽅法で当社に対して登録情報の提供を⾏うものとします。当社
            は、受領した登録情報について、当社が別途定める掲載基準に従って掲載の可否を判断し、
            掲載を認める場合にはその旨を事業者等に通知します。
          </List>
          <List>
            事業者等は、当社から、施設の設備の詳細、本サイトを通じて知り得た利用者に関する予約
            状況・過去の利⽤状況・利用者とのやり取りやその他の事項について問合せ⼜は資料提供の
            要請を受けた場合は、遅滞なく回答⼜は資料の提供を⾏うものとします。
          </List>
          <List>
            コンテンツ事業者は、以下に定める事項を保証するものとします。
            {OL(["法令等(特定商取引法、不当景品類および不当表示防止法、個人情報の保護に関する法律、所管の官公庁の定めるガイドライン、コンテンツ事業者が所属する業界団体が定める自主ルール等を含みます。)に違反していないこと", "当社へのコンテンツ提供に関して正当な権限を有し(権利を有する第三者からコンテンツ事業者が利用許諾を受けている場合を含みます。)、第三者の著作権、商標権、肖像権、パブリシティ権その他一切の権利を侵害しないこと", "虚偽の内容又は利用者を誤認させる内容を含まないこと"])}
          </List>
          <List>
            {" "}
            コンテンツ事業者は、本サービスと同一又は類似の第三者が運営するサービス(以下「他者
            サービス」といいます。)を利用している場合、利用料金の決定にあたり、他者サービスにおけ
            る利用料金と本サービスにおける利用料金との間で不平等となるような料金設定とならないよ
            うに十分留意するものとします。
          </List>
          <List>
            事業者等は、当社が認める場合を除き、複数のアカウントを持つことはできません。また、事業
            者等は自己のアカウントを第三者に譲渡その他の方法により移転すること（相続及び合併等
            の包括承継を含みます。）はできません。
          </List>
        </ol>
        <Subtitle>第 6 条 個別契約の成⽴等</Subtitle>
        <ol>
          {ListItems(["事業者等は、当社に対して登録情報を提供する際に、キャンセルポリシーその他の施設の利⽤に関する諸条件（利⽤料⾦に対してサービス料並びに消費税及び地方消費税以外の税⾦(ホテル税・⼊湯税等)が発⽣する場合を含み、これらに限りません。以下利用料金と併せて「利用料金等」といいます。）をあわせて提供するものとします。", "利用者からの事業者等に対する利用申込み（以下「予約リクエスト」といいます。）に対し、事業者等が当社ウェブサイト等の管理画面上で承認の意思表示をした時点で、利用者と事業者等との間に、利用者規約で定める事項及び前項の利用者・事業者等との間で別途合意した事項（事業者等が利用者に別途、事前に提⽰する独自の利⽤規約等を含みますがこれらに限りません。）を内容とする当該施設の利用に関する契約（以下「個別契約」といいます。）が成立するものとします。個別契約成立後の利用料金等の変更は、利用者の明確な同意がない限りできないものとし、利用者に対して返答期限を一方的に設定して、同期限を徒過したことをもって利用料金等の変更がなされたものとみなすことはできません。"])}
          <List>
            事業者等は、当社が利用者による利⽤に関し下記事項に該当すると判断した場合には、当
            社の要請に基づき、利用者による利⽤を中⽌させ、又は、個別契約を解除しなければなりま
            せん。
            {OL(["当社が⾵紀上又は安全管理上、不適当と認めた場合。", "関係諸官庁又は施設関係者から施設利⽤の中⽌命令が出された場合。", "利用者が当社諸規約に反する利用をした場合。", "暴⼒団等に属する者が利⽤しようとしている認められる場合。", "利用者が、利⽤に関し、法令の規定、公の秩序又は善良の⾵俗に反する⾏為をするおそれがあると認められる場合。", "利用者が、感染症又は伝染病に罹患していると明らかに認められる場合。", "天災、施設の故障その他やむを得ない事由により利⽤させることができない場合。", "施設が所在する地域の条例･規則の規定に抵触する場合。", "その他、当社又は事業者等が社会通念上不適切な使⽤⽅法と判断した場合。"])}
          </List>
          {ListItems(["個別契約成立後、事業者等は利用者に対し、利用方法を案内する等利用者による利用に支障がないよう適切な対応をしなければならず、当該対応が行われていないと当社が判断した場合、当社は、事業者等の意向如何にかかわらず、利用料金等の払戻しの手続きを行います。この場合、利用料金等全額を返金するものとし、当該返⾦により事業者等に⽣じた損害について、当社は⼀切責任を負いません。", "事業者等が前項の義務に違反し、利用者に損害が生じた場合には、事業者等は利用者に対し、その損害を賠償しなければなりません。", "施設及び／又はコンテンツの当社ウェブサイト等への掲載が社会通念上不適切であると判断される場合には、当社は、当該情報を削除できるものとします。この場合、事業者等にいかなる損害が生じても、当社は一切責任を負いません。", "当社は、事業者等が利用者の予約リクエストに対して返信を行わない等、事業者等による利用者との個別契約の締結及びその適切かつ誠実な履行が期待できないと判断した場合は、事業者等へ通知した上で、事業者等が掲載する情報に関し、非掲載等の措置を行うことができるものとします。"])}
        </ol>
        <Subtitle>第 7 条 再委託</Subtitle>
        <Content>
          当社は、⾃⼰の裁量に基づき本サービスの運営の全部⼜は⼀部を他の第三者に再委託すること
          ができるものとします。
        </Content>
        <Subtitle>第 8 条 プラットフォーム利⽤料</Subtitle>
        <ol>
          <List>
            事業者等は、当社に対し、プラットフォーム利⽤料として、事業者等が利用者から取得する利
            ⽤料⾦（消費税及び地方消費税を含みます。以下本条において同じ。）の
            15％に相当する
            ⾦額及びそれに係る消費税及び地方消費税相当額を⽀払うものとします。
          </List>
          <List>
            また、プラットフォーム利用料の計算の基礎となる利用料金には、以下の金員も含むものとし
            ます。
            {OL(["利用者が個別契約をキャンセルした場合で、第 9 条に定めるキャンセルポリシーに従って事業者等が利用者から受領したキャンセル料金", "利用時間延長、無断利用、退去遅延等に伴い、事業者等から利用者に対し請求する利用料金、損害賠償金又は違約金（什器備品等の損壊による損害賠償金は含みません。）"])}
          </List>

          {ListItems(["事業者等は、当社に対し、利用者が⽀払う個別契約に基づく利⽤料⾦等（宿泊料⾦を含みます。以下同じ。）を、⾃⼰を代理して受領する権限を付与します。施設事業者は、当社の事前の承諾を得ない限り、利用者から直接個別契約に基づく利⽤料⾦等を受領してはなりません。", "当社は、前項に基づき利用者から利⽤料⾦等を受領した場合、個別契約に基づいて利用者による利用初日から起算して7日前の日を基準日として、直後の五・十日（但し、五・十日が翌日にあたる場合は、基準日より4日後以降の五・十日とし、金融機関が休業日の場合は前営業日とします。例：某月16日が利用初日であれば、15日）に利用料金から第1項に定めるプラットフォーム利用料を控除した金額を事業者等に対して支払うものとします。なお、銀行振込手数料その他支払に要する費用は当社の負担とします。", "本条に基づき当社へ⽀払われたプラットフォーム利⽤料については、その後事業者等が何らかの事情により利用者、その他の第三者に対して返⾦等した場合でも、それによる影響を受けないものとし、いかなる場合も当社は事業者等に対して返⾦する義務を負わないものとします。"])}
        </ol>
        <Subtitle>第 9 条 キャンセル時の対応</Subtitle>
        <ol>
          <List>
            事業者等は、当社に対し、利用者によるキャンセル（以下「利用者キャンセル」といいます。）
            に関する諸条件を提供するものとし、当社が別途定める利用者キャンセルに関する下記の
            キャンセルポリシー（以下「キャンセルポリシー」といいます。）に従って適切に利用者からの
            キャンセルを受け付けるものとします。
          </List>
          <Content>記</Content>
          <table>
            <tr>
              <td>契約成立～利用14日前まで</td>
              <td>無料</td>
            </tr>
            <tr>
              <td>利用14日前～8日前まで</td>
              <td>利用料金総額の50％</td>
            </tr>
            <tr>
              <td>利用7日前～利用当日まで</td>
              <td>利用料金総額の100％</td>
            </tr>
          </table>
          <Content>
            ※「利用●日前」とは、利用日が複数にわたる場合には利用初日を起算点として計算するもの（利
            用初日を利用当日とし、その前日を利用1日前…以下同じ）とします。
          </Content>
          {ListItems(["事業者等は、前項の利用者キャンセルに対し、適時に当社ウェブサイト等上で対応をしなければなりません。", "事業者等によるキャンセル（以下「事業者等キャンセル」といいます。）をする場合には、事業者等はキャンセル料を受領することはできず、利用者に対して利用料金等を全額返金しなければなりません。", " 利用者キャンセルの手続き後、事業者等が７日間、第2項の手続きを行わなかった場合、当社にて払戻しの手続きを行います。この場合、キャンセルポリシーの設定の如何にかかわらず、利用料金全額を返金するものとし、当該返⾦により事業者等に⽣じた損害について、当社は⼀切責任を負いません。"])}
        </ol>

        <Subtitle>第 10 条 パスワード及び施設事業者 ID の管理</Subtitle>
        {OL([" 事業者等は、⾃⼰の責任において、本サービスに関するパスワード及び事業者等IDを適切に管理及び保管するものとし、これを第三者に利⽤させ、又は貸与、譲渡、名義変更、売買等をしてはなりません。", "パスワード又は事業者等IDの管理不⼗分、使⽤上の過誤、第三者の使⽤等によって⽣じた損害に関する責任は事業者等が負うものとします。"])}
        <Subtitle>第 11 条 本サービスの停⽌等</Subtitle>
        <ol>
          <List>
            当社は、以下のいずれかの事由が生じた場合には、事業者等に事前に通知することなく、本
            サービスの全部⼜は⼀部の提供を停⽌⼜は中断することができるものとします。
            {OL(["本サービスに係るコンピューター・システムの点検又は保守作業を定期的又は緊急に行う場合", " コンピューター、通信回線等が事故により停止した場合", "地震、落雷、⽕災、⾵⽔害、停電、天変地異などの不可抗力により本サービスの運営ができなくなった場合", "外部SNSサービスに、トラブル、サービス提供の中断又は停止、本サービスとの連携の停止、仕様変更等が生じた場合", "本サービスの提供に必要な設備の障害等により本サービスの提供が困難となった場合", "その他、当社が停止又は中断を必要と判断した場合"])}
          </List>
          {ListItems(["当社は、当社の都合により、本サービスの提供を終了することができます。この場合、当社は事業者等に事前に通知するものとします。", "当社は、本条に基づき当社が行った措置に基づき事業者等に生じた損害について一切の責任を負いません。"])}
        </ol>
        <Subtitle>第 12 条 知的財産権等</Subtitle>
        {OL([" 当社ウェブサイト等及び本サービスに関する知的財産権は、全て当社⼜は当社にライセンスを許諾している者に帰属しており、利⽤契約は、本サイト又は本サービスに関する当社⼜は当社にライセンスを許諾している者の知的財産権の使⽤許諾を意味するものではありません。", "事業者等は、当社⼜はその委託先が撮影した写真素材について、当社の事前の許可なく、当社ウェブサイト等以外の他のサイト、パンフレットその他の媒体に使⽤してはなりません。", "事業者等は、登録情報について、⾃らが当該登録情報を当社ウェブサイト等上に掲載することについて適法な権利を有していること、施設及びコンテンツの所有権を保有し、⼜は、施設及びコンテンツの所有者から転貸若しくは第三者へ利用させることの承諾を得ていること、並びに登録情報が真実かつ正確であり、第三者の権利を侵害していないことについて、当社に対し表明し、保証するものとします。なお、登録情報と現況が異なる場合には、当社は事業者等に対し、登録情報の加除訂正を求めることができるものとします。", "当社は、本サービスの提供に必要な範囲で、事業者等及び施設及びコンテンツの名称、商標、ロゴ、画像を⾃由に使⽤できるものとします。但し、使⽤にあたっては事業者等のブランディングを最⼤限考慮するものとし、事業者等は⾃らのブランディングの観点から当社に対して、必要に応じてその使⽤⽅法について指定及び変更の申し⼊れを⾏うことができるものとします。", "事業者等は、当社に対し、事業者等が当社に提供した資料又は情報（カレンダー連携のために提供する情報を含みますが、これに限りません。）の⼀部又は全部を、利⽤、複製、実施、表⽰、頒布、修正、⼆次的著作物の作成その他⽅法の如何を問わず、商業的⼜は⾮商業的に有効利⽤する、無償の、⾮独占的で恒久的かつ取り消し不可能な権利を付与するものとします。"])}

        <Subtitle>第 13 条 保証の否認及び免責</Subtitle>
        {OL(["当社は、本サービスが事業者等の特定の⽬的に適合すること、事業者等による本サービスの利⽤が事業者等に適⽤のある法令⼜は業界団体の内部規則、事業者等が締結する契約等に適合すること、並びに利用者規約に基づく施設の個別契約が法令上、定期建物賃貸借契約と解釈される余地がないことについて、何ら保証するものではありません。", "当社は、事業者等が本サービスを利⽤することにより、⼀定の収益を得られることを何ら保証するものではありません。", "利用に関する個別契約は事業者等と利用者間の契約であり、当社は、盗難、事故、機器の故障、⽕災、⾬漏りその他のトラブルについて、⼀切責任を負いません。", "利用に関する個別契約は事業者等と利用者間の契約であり、当社は、利用者による不正利⽤、器物損壊、無断キャンセルその他利用者が事業者等に対して与えた損害について⼀切責任を負いません。"])}

        <Subtitle>第 14 条 紛争処理等</Subtitle>
        {OL(["事業者等が適法に施設及びコンテンツを運営できる権利を有していないことが発覚した場合、当社は、当該情報を削除できるものとします。この場合において、事業者等にいかなる損害が生じても、当社は一切責任を負わない一方、利用者又は当社に損害が生じた場合には、事業者等は利用者又は当社に対し、その損害を賠償しなければなりません。", "事業者等は、当社による本サービスの提供又は利用者による利用に関して、利用者その他の第三者からクレーム、損害賠償請求その他の請求⼜は主張がなされた場合には、遅滞なく当社に通知します。", "事業者等は、本サービスの利⽤、個別契約又は利用者による利用に関して、利用者その他の第三者からクレーム、損害賠償請求その他の請求又は主張がなされた場合には、全て事業者等の責任と費⽤において解決するものとします。また、事業者等はかかる請求⼜は主張に関して当社が被った損害（弁護⼠費⽤、第三者から請求された賠償額を含む。）及び損失を賠償⼜は補償します。", "前2項の利用者その他の第三者からの請求⼜は主張に関して、当社は、可能な範囲で誠意をもって当該紛争の解決に協⼒するものとします。"])}

        <Subtitle>第 15 条 直接取引の禁⽌</Subtitle>
        {OL(["事業者等は当社の事前の承諾なく、本サービスを利⽤して連絡をとった利用者に対し、すでに確⽴されている本サイトの販売⼿順を回避する⾏為や、利用者を他の Web サイト誘導する⾏為（施設及びコンテンツ掲載欄やメッセージ内で、URL やメールアドレスを書き込む行為等を含みますが、これに限りません。）をしてはなりません。また本サービスを利⽤せず当該利用者と直接利⽤に関する契約を締結してはなりません。", "前項に違反した場合、及び前項に違反するおそれがあると当社が判断し、事業者等に対して合理的説明を求めたにもかかわらず、当社が定める⼀定期間内に当該説明をすることができなかった場合、事業者等は、当社に対し、前項に違反した直接の契約が本サービスを利⽤して⾏われたとした場合に当社が得ることができたであろう収益⼜は第１項の違反が発覚した時点の直近６ヶ⽉間に当社が事業者等から受領したプラットフォーム利⽤料のいずれか⾼い⽅の2倍の⾦額を⽀払わなければなりません。また、この場合、当社は事業者等に対し、事前の通知なしに当社ウェブサイト等上の掲載情報の削除、サービスの全部又は⼀部の利⽤停⽌、登録の取消しその他当社が必要と判断する措置を講じることができるものとします。"])}
        <Subtitle>第 16 条 競業避⽌</Subtitle>
        {OL(["事業者等は、利⽤契約期間中、本サービスと競合するサービスを⾃ら⾏わないものとします。", "前項の規定は、利⽤契約終了後 1 年間有効に存続するものとします。"])}
        <Subtitle>第 17 条 損害賠償</Subtitle>
        <Content>
          事業者等は、当社諸規約に違反して相⼿⽅に損害を及ぼした場合には、その損害を賠償する責
          任を負います。但し、当社の賠償責任は、当該損害の原因となった施設に関するプラットフォーム
          利⽤料に相当する額を上限とします。
        </Content>
        <Subtitle>第 18 条 不可抗⼒</Subtitle>
        <Content>
          当社は、⾃らの合理的な⽀配の及ばない状況（⽕事、停電、ハッキング、コンピューターウィルスの
          侵⼊、地震、洪⽔、戦争、疫病、感染症、通商停⽌、ストライキ、暴動、物資及び輸送施設の確
          保不能、政府当局による介⼊、⼜は内外法令の制定若しくは改廃を含むがこれらに限定されませ
          ん。）により利⽤契約上の義務の履⾏が遅延した場合、その状態が継続する期間中、施設事業者
          に対し債務不履⾏責任を負わないものとします。
        </Content>
        <Subtitle>第 19 条 有効期間</Subtitle>
        <Content>
          本規約は、第3条に基づく登録が完了した⽇に効⼒を⽣じ、当該事業者等の登録が取り消された
          ⽇⼜は本サービスの提供が終了した⽇のいずれか早い⽇まで、当社と事業者等との間で有効に
          存続するものとします。
        </Content>

        <Subtitle>第 20 条 登録取消等</Subtitle>
        <ol>
          <List>
            当社は、事業者等に次の各号に掲げる事由の⼀つが⽣じたときには、催告を要せず、当該事
            業者等について本サービスの利⽤を⼀時的に停⽌し、⼜は事業者等としての登録を取り消
            すことができます。
            {OL(["当社諸規約に違反し、その是正を求める通知を受領後15⽇以内に当該違反の是正又は当該違反に基づく損害の賠償をしないとき", "⽀払停⽌若しくは⽀払不能となり、⼜は、破産⼿続開始、⺠事再⽣⼿続開始若しくは会社更⽣⼿続開始その他これらに類する⼿続開始の申⽴てがあったとき", "振出し、⼜は、引き受けた⼿形⼜は⼩切⼿が不渡りとなったとき", "仮差押え若しくは仮処分の命令を受け、その効⼒が15⽇以上継続した場合、⼜は差押え若しくは競売の申⽴てを受けたとき", "公租公課の滞納処分を受けたとき", "解散したとき（合併による場合を除く）、清算開始となったとき、⼜は事業の全部（実質的に全部の場合を含む。）を第三者に譲渡したとき", "監督官庁から営業停⽌⼜は営業免許若しくは営業登録の取消等の処分を受けたとき", "資産若しくは信⽤状態が悪化し、⼜はそのおそれがあると認められる相当の理由があるとき", "宿泊サービスを提供する施設事業者が宿泊サービスを提供するために必要な旅館業法上の許可若しくは国家戦略特別区域法上の特定認定その他の宿泊サービスを提供するために必要な許認可が取り消されたとき⼜は施設事業者が提供する施設が、旅館業法、国家戦略特別区域法その他関係する法令等で定める要件を満たさなくなったとき", "当社が施設事業者の旅館業法上の許可⼜は特定認定の取り消しの事実を認識したとき、宿泊サービスのために利⽤される施設が法令に定める宿泊サービスを提供するための条件に該当しないと当社が判断したとき、又は施設の登録申請の内容に虚偽があると明らかに認められたとき", "反社会的勢力等であることが判明したとき（決済代行会社が反社会的勢力等であると認定した場合を含む。）"])}
          </List>

          {ListItems(["事業者等に前項に掲げる事由の⼀つが発⽣した場合、事業者等の当社に対する債務は当然に期限の利益を失い、事業者等は全ての債務を当社に弁済しなければならず、また、当社は事業者等に対する債務の履行を留保することができるものとします。", "第1項の解除権の⾏使は、第17条による損害賠償請求権を妨げるものではありません。", "事業者等は、任意に⾃⼰の事業者等としての登録を取り消すことができます。", "事業者等は、自己の事業者等としての登録を取り消し、又は、取り消された場合であっても、当該時点で成立していた個別契約については、当社の指示に従い、適切に履行する義務を負うものとします。", "事業者等が前項の義務に違反し、利用者に損害が生じた場合には、事業者等は利用者に対し、その損害を賠償しなければなりません。"])}
        </ol>
        <Subtitle>第 21 条 反社会的勢⼒等の排除</Subtitle>
        {OL(["本規約の当事者は、相⼿⽅が反社会的勢⼒等であることが判明したとき（決済代行会社が反社会的勢力等であると認定した場合を含む。）には、催告を要せず相⼿⽅に書⾯又は電子メールで通知することにより直ちに利⽤契約を将来に向かって解除することができます。", "相⼿⽅が利⽤契約に関連して締結した契約（以下「関連契約」といいます。）の当事者⼜はその当事者の代理⼈若しくは締結を媒介した者が反社会的勢⼒等であることが判明した場合には、利⽤契約の当事者は相⼿⽅に対し、当該関連契約の解除その他の必要な措置を講ずるよう求めることができるものとします。", "前項に基づいて必要な措置を講ずるよう求めたにもかかわらず、相⼿⽅が正当な理由なくこれを拒否した場合、利⽤契約の当事者は催告を要せず相⼿⽅に書⾯又は電子メールで通知することにより直ちに利⽤契約を将来に向かって解除することができるものとします。", " 前各項に定める場合を除き、本規約の当事者は、相⼿⽅の取締役、監査役、従業員その他の構成員、株主、取引先、若しくは顧問その他のアドバイザーが反社会的勢⼒等であること、⼜は相⼿⽅が資⾦提供その他を通じて反社会的勢⼒等の維持、運営若しくは経営に協⼒若しくは関与する等反社会的勢⼒等との何らかの交流若しくは関与を⾏っていることが判明した場合において、その解消を求める通知を相⼿⽅が受領後相当期間内にこれを解消しないときは、相⼿⽅に対し、書⾯又は電子メールで通知することにより、直ちに利⽤契約を将来に向かって解除することができるものとします。", " 本条に基づき利⽤契約を解除した当事者は、当該解除により相⼿⽅に⽣じた損害の賠償責任を負わないものとします。また、本条に基づいて本規約を解除した場合、当社は、第8条第5項に基づいて事業者等に振り込むべき利用料金等を没収するものとします。"])}

        <Subtitle>第 22 条 秘密保持</Subtitle>
        <ol>
          <List>
            本規約において「秘密情報」とは、本規約又は本サービスに関連して、事業者等が、当社より
            書面、口頭若しくは記録媒体等により提供若しくは開示されたか、又は知り得た、当社の技
            術、営業、業務、財務、組織、その他の事項に関する全ての情報を意味します。但し、以下の
            いずれかに該当する情報については、秘密情報から除外するものとします。
            {OL(["当社から提供若しくは開示がなされたとき又は知得したときに、既に一般に公知となっていた、又は既に知得していたもの", " 当社から提供若しくは開示又は知得した後、自己の責めに帰せざる事由により刊行物その他により公知となったもの", "提供又は開示の権限のある第三者から秘密保持義務を負わされることなく適法に取得したもの", "秘密情報によることなく単独で開発したもの", "当社から秘密保持の必要なき旨書面で確認されたもの"])}
          </List>

          {ListItems(["事業者等は、秘密情報を本サービスの利用の目的のみに利用するとともに、当社の書面による承諾なしに第三者に当社の秘密情報を提供、開示又は漏洩しないものとします。", "第2項の定めにかかわらず、事業者等は、法律、裁判所又は政府機関の命令、要求又は要請に基づき、秘密情報を開示することができます。但し、当該命令、要求又は要請があった場合、速やかにその旨を当社に通知しなければなりません。", "事業者等は、秘密情報を記載した文書又は磁気記録媒体等を複製する場合には、事前に当社の書面による承諾を得ることとし、複製物の管理については第2項に準じて厳重に行うものとします。", "事業者等は、当社から求められた場合にはいつでも、遅滞なく、当社の指示に従い、秘密情報並びに秘密情報を記載又は包含した書面その他の記録媒体物及びその全ての複製物を返却又は廃棄しなければなりません。"])}
        </ol>

        <Subtitle>第 23 条 個⼈情報の取扱い</Subtitle>
        <ol>
          <List>
            利⽤契約の当事者は、個⼈情報保護の重要性を認識し、個⼈情報の取扱いにあたっては、
            当社諸規約のほか、個⼈情報保護法を遵守するものとします。また、利⽤契約の当事者は、
            個⼈情報の紛失、破壊、改ざん又は漏洩などのリスクに対して個⼈情報の安全管理が図られ
            るよう、⾃社の役員及び従業員に対し、必要かつ適切な監督を⾏うものとします。
          </List>
          <List>
            事業者等は、本サービスを通じて取得した利用者の個⼈情報を、本サービスの利⽤に必要な
            範囲で、かつ、
            <a href="https://drive.google.com/file/d/1FzC4WIgC0ujH30dZIf4d7mAKH5C_Jf4z/view?usp=sharing">
              プライバシーポリシー
            </a>
            に記載された利⽤⽬的の範囲内で利⽤するものとしま す。
          </List>
          <List>
            事業者等は、本サービスを通じて取得した利用者の個⼈情報を利⽤して、利用者に対して電
            ⼦メール広告（特定商取引に関する法律第 12 条の 3 第 1
            項における「電⼦メール広告」を 意味します）を⾏ってはなりません。
          </List>
        </ol>
        <Subtitle>第 24 条 本規約の変更</Subtitle>
        {OL([" 当社は、本サービスの内容を⾃由に変更できるものとします。", "当社は、当社諸規約を任意に変更できるものとします。但し、当社諸規約を変更する場合には、その効力発生時期を定め、かつ、規約を変更する旨及び変更後の規約の内容並びにその効力発生時期をインターネットの利用その他の適切な方法により事業者等に周知するものとし、当該周知後、事業者等が本サービスを利用した場合又は当社の定める期間内に登録取消の手続をとらなかった場合には、事業者等は、当社諸規約の変更に同意したものとみなします。"])}

        <Subtitle>第 25 条 譲渡禁⽌</Subtitle>
        {OL(["事業者等は、当社の書⾯又はメールによる事前の同意なくして、利⽤契約の契約上の地位、当該契約に基づく権利及び義務につき、第三者に対する譲渡（運営会社の変更を含みます。）、担保設定、その他の処分をしてはならないものとします。", "当社は本サービスにかかる事業を他社に譲渡した場合には、当該事業譲渡に伴い本利⽤契約上の地位、当該契約に基づく権利及び義務並びに施設事業者の登録情報その他の顧客情報を当該事業譲渡の譲受⼈に譲渡することができるものとし、施設事業者は、かかる譲渡につき本項において予め同意したものとします。なお、本項に定める事業譲渡には、通常の事業譲渡のみならず、会社分割その他事業が移転するあらゆる場合を含むものとします。", "事業者等は、本規約上の地位、施設の所有権若しくは賃借権又は本本規約に基づく権利若しくは義務を第三者に対して譲渡した場合において、その移転方法や本サービスの利用に関する一切の事項について、当社がいかなる目的においても事業者等その他の第三者の代理人ではなく、一切責任を負わないことについて予め同意するとともに、譲渡人・譲受人間で誠実に協議し、利用者又は第三者に不利益を生じさせない義務があることを確認するものとします。"])}
        <Subtitle>第 26 条 完全合意</Subtitle>
        <Content>
          当社諸規約は、当社諸規約に含まれる事項に関する当社と事業者等との完全な合意を構成し、口
          頭又は書面を問わず、当社諸規約に含まれる事項に関する当社と事業者等との事前の合意、表
          明及び了解に優先します。
        </Content>
        <Subtitle>第 27 条 分離可能性</Subtitle>
        <Content>
          本規約のいずれかの条項又はその一部が無効又は執行不能と判断された場合であっても、本規
          約の残りの規定並びに一部が無効若しくは執行不能と判断された規定の残りの部分は、継続して
          完全に効力を有し、当社及び事業者等は、当該無効又は執行不能の条項又は部分以外の規定
          を適法とし、執行力を持たせるために必要な範囲で修正し、当該無効又は執行不能な条項又は部
          分の趣旨と法律的及び経済的に同等の効果を確保できるように努めるものとします。
        </Content>
        <Subtitle>第 28 条 存続規定</Subtitle>
        <Content>
          第5条第5項、第8条（但し、未払いがある場合に限る。）、第9条第3項及び第4項、第10条第2項、
          第11条第2項、第12条から第18条まで、第20条第2項及び第3項、第21条第5項、第22条から第29
          条までの規定は、本規約終了後も有効に存続します。但し、第15条及び第16条については、本規
          約終了後1年間に限り存続するものとし、第22条については本規約の有効期間終了後3
          年間に限 り存続するものとします。
        </Content>
        <Subtitle>第 29 条 準拠法及び合意管轄</Subtitle>
        <Content>
          当社諸規約の準拠法は⽇本法とし、当社諸規約に関連して⽣じた紛争については、東京地⽅裁
          判所を第⼀審の専属的合意管轄裁判所とします。
        </Content>
        <Subtitle>第 30 条 協議事項</Subtitle>
        <Content>
          当社諸規約に定めのない事項及び解釈の疑義については、法令の規定並びに慣習に従うほか、
          両当事者誠意をもって協議解決を図るものとします。
        </Content>
        <Content right>
          {"2021年6月30日制定\n2021年7月30日改訂\n2023年8月31日改訂"}
        </Content>
      </Container>
    </>;
};

export default Privacy;

require("./index.linaria.module.css!=!../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./index.tsx");